import React, {Component} from 'react';
import {getStarColor, randomColor} from 'utils/colors';


export class Loading extends Component{
	
	static defaultProps = {
		numStars: 375,
		starRatio: 1024,
		randomColors: false,
		canvasStyle: {
			position: "absolute",
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			width: "100%",
			height: "100%",
		},
		maxSizeMult: 10,
		invert: true,
		fillOpacity: 0.9
	};

	constructor(props){
		super(props);
		
		this.star = [];
		this.starSpeed = 1;
		this.cursor = this.getCenter();
		this.mouse = {...this.cursor};

		this.canvasx = 0;
		this.canvasy = 0;

		this.state = {};
	}

	componentDidMount(){
		window.addEventListener("resize", this.onResize);
		this.mounted = true;
	}

    componentWillUnmount(){
    	document.body.style.overflow = "auto";
		window.removeEventListener("resize", this.onResize);
		this.mounted = false;
		this.saveAnimationState();
	}
	
	saveAnimationState = () => {
		window._lastLoadingAnimationState = {
			mouse: this.mouse,
			cursor: this.cursor,
			starRatio: this.props.starRatio,
			lastAlpha: this.lastAlpha,
			lastStarColor: this.lastStarColor,
			perspectiveOrigin: this.perspectiveOrigin,
			star: this.star,
			fillOpacity: this.fillOpacity,
			starSpeed: this.starSpeed
		};
	}

	restoreAnimationState = () => {
		const last = window._lastLoadingAnimationState;
		if (last) {
			for (let prop in last) {
				this[prop] = last[prop];
			}
		}
	}

	getCenter = (integersOnly=true) => {
		this.doc = {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight
		};
		let center = {
			x: this.doc.width * 0.5,
			y: this.doc.height * 0.5
		}
		if (integersOnly){
			center.x = Math.round(center.x);
			center.y = Math.round(center.y);
		}
		return center;
	}

	onResize = e => {
		let {canvas, context} = this.state;
		
		let center = this.getCenter();
		this.cursor = {...center}
		this.perspectiveOrigin = {
			...center,
			z: (this.doc.width + this.doc.height) * 0.5
		};
		this.star_color_ratio = 1 / this.perspectiveOrigin.z;
		if (canvas){
			canvas.width = this.doc.width;
			canvas.height = this.doc.height;
		}
		this.init();
	}

	randomStar = (newStar=true, i) => ({
		x: Math.random()
				* (this.doc.width * 2)
				- this.perspectiveOrigin.x * 2,
		y: Math.random()
				* (this.doc.height * 2)
				- this.perspectiveOrigin.y * 2,
		z: newStar ? (
			Math.round(Math.random()
				* this.perspectiveOrigin.z)
		) : this.perspectiveOrigin.z,
		xsave: 0,
		ysave: 0,
		color: {r: 0, g: 0, b: 0, a: 1},
		colorHex: '#000000',
		sizeMult: (Math.random() * this.props.maxSizeMult) + 1,
		lastOff: true
	})

	reStar = (i) => {
		// this.star.push(this.randomStar());
		// return;
		if (!this.star[i].lastOff){
			this.star[i].x = Math.random() * (this.doc.width * 2)
				- this.perspectiveOrigin.x * 2;
			this.star[i].y = Math.random() * (this.doc.height * 2)
				- this.perspectiveOrigin.y * 2;
			// this.star[i].z = this.perspectiveOrigin.z;
			this.star[i].z = Math.round(Math.random()
				* this.perspectiveOrigin.z) + 500;
			this.star[i].sizeMult = (
					Math.random() * this.props.maxSizeMult
				) + 1;
			this.star[i].lastOff = true;
		}
	}


	init = () => {
		let {
			numStars,
			randomColors,
			invert,
			maxSizeMult,
			fillOpacity
		} = this.props;
		let {canvas, context} = this.state;

		for(var i=0; i < numStars; i++){
			this.star[i] = this.randomStar(i);
		}

		canvas.width = this.doc.width;
		canvas.height = this.doc.height;

		this.fillOpacity = fillOpacity;
		this.updateFillStyle();
		context.lineCap = "round";
		context.strokeStyle = '#000000';

		if (!this.started){
			this.restoreAnimationState();
			this.anim();
			this.started = true;
		}
	}


	getBackgroundColor = () => {
		let shade = this.state.inverted ? 255 : 0;
		return `rgba(${shade}, ${shade}, ${shade}, ${this.fillOpacity})`;
	}

	updateFillStyle = () => {
		this.state.context.fillStyle = this.getBackgroundColor();
	}

	anim = () => {
		let {
			starRatio
		} = this.props;
		let {
			canvas,
			context,
		} = this.state;

		if (!this.mounted){
			return;
		}

		this.mouse.x = this.cursor.x - this.perspectiveOrigin.x;
		this.mouse.y = this.cursor.y - this.perspectiveOrigin.y;

		// context.fillRect(0, 0, this.doc.width, this.doc.height);
		context.clearRect(0, 0, this.doc.width, this.doc.height);
		// canvas.width = canvas.width;

		let t;
		var s;
		let numStars = this.star.length;
		this.setStarColor(`#000000`)
		for(let i = 0; i < numStars; i++){
			s = this.star[i];
			t = true;
			this.star_x_save = s.xsave;
			this.star_y_save = s.ysave;

			

			s.x += this.mouse.x >> 4; 
			if(s.x > this.perspectiveOrigin.x << 1){
				s.x -= this.doc.width << 1;
				t = false;
			}
			if(s.x < -this.perspectiveOrigin.x << 1){
				s.x += this.doc.width<<1;
				t = false;
			}

			s.y += this.mouse.y >> 4; 
			if(s.y + (myLineWidth * 2) > this.perspectiveOrigin.y << 1){
				s.y -= this.doc.height << 1;
				t = false; 
			} 
			if(s.y + (myLineWidth * 2) < -this.perspectiveOrigin.y << 1){
				s.y += this.doc.height << 1;
				t = false;
			}

			s.z -= this.starSpeed; 
			if(s.z > this.perspectiveOrigin.z){
				s.z -= this.perspectiveOrigin.z;
				t = false;
			}
			
			
			s.color.a = 1 - (s.z / this.perspectiveOrigin.z);
				// + 0.25;
			var myLineWidth = (1 - this.star_color_ratio * s.z) + s.sizeMult;

			var done = false;
			if(s.z < 0 - myLineWidth) {
				s.z += this.perspectiveOrigin.z;
				t = false;
				done = true;
			}
			s.xsave = this.perspectiveOrigin.x
				+ (s.x / s.z) * starRatio;
			s.ysave = this.perspectiveOrigin.y
				+ (s.y / s.z) * starRatio;

				if(	t && 
				(this.star_x_save > 0 - myLineWidth)
					&& (this.star_x_save < this.doc.width + myLineWidth)
					&& (this.star_y_save > 0 - myLineWidth)
					&& (this.star_y_save < this.doc.height + myLineWidth)){
					this.star[i].lastOff = false;
					let newAlpha = s.color.a;
					if (this.lastAlpha !== newAlpha){
						this.lastAlpha = newAlpha;
						context.globalAlpha = this.lastAlpha;
					}
					context.lineWidth = myLineWidth;
					context.beginPath();
					context.lineCap = "round";
					context.moveTo(this.star_x_save, this.star_y_save);
					context.lineTo(s.xsave, s.ysave);
					context.stroke();
					context.closePath();
			}
			// if (done){
			// 	this.reStar(i);
			// }
		}
		if (this.mounted){
			window.requestAnimationFrame(this.anim);
		}
	}


	setStarColor = color => {
		let {context} = this.state;
		if (context) {
			if (color !== this.lastStarColor){
				context.strokeStyle = color; 
				this.lastStarColor = color;
			}
		}
	}

	canvasLoaded = canvas => {
		if (canvas){
			// keeping the canvas and context in state
			// instead of this prevents it being wiped out
			// on state change
			this.setState({
				canvas,
				context: canvas.getContext('2d')
			}, () => {
				this.onResize();
			});
		}
	}

	mouseMove = (e) => {
		this.cursor = {
			x: e.pageX - this.canvasx,
			y: e.pageY - this.canvasy
		}
	}

	render(){
		let {
			ready,
			inverted
		} = this.state;
		let {
			canvasStyle,
		} = this.props;
		return (
			<div className="wrap-starfield">
				<canvas
					id="starfield"
					key="starfield"
					ref={this.canvasLoaded}
					style={{...canvasStyle}}
					className="starfield"
				/>
			</div>
		)
	}

}
export default Loading;